import Task from "../../task";
import {modalAddTaskUser} from "../../../../gd-modals/users/add-user";

export default function taskAddUserAsAssignee(task:Task) {

    // if (!task.acl.canAddProjectUser) return
    if (!task.acl.canAddUser) return

    modalAddTaskUser(task, {
        multiselect     : false,
        callback        : (manager) => {
            const userId = manager.allUsersToAddSelected[0]?.user.id
            if (!userId) return

            task.assignedToUserId = userId
            task.save()
        }
    })

    /*gd.modals.task.addUser2(
        task,
        async (userId:ID, access: any, type: any)=>{

            await gd.api.Task.addUsers(task.id, [{userId, access, type}]).promise()

            task.assignedToUserId = userId
            task.save()

        }
    )*/
}
